import React, { FC, useCallback, useMemo } from 'react';
import PlainDropDown from 'src/common/PlainDropDown';
import { useLoadAllMpsIds } from 'src/models/matchingProfiles/hooks';
import { useTranslation } from 'react-i18next';
import { ProfileType } from '@tendium/prom-types';

export interface IProps {
  updateSelectValue: (mpId?: string) => void;
  placeholder?: string;
  selectedValue?: string;
  isMp?: boolean;
}

export const MPSelect: FC<IProps> = props => {
  const { placeholder, selectedValue, updateSelectValue, isMp } = props;
  const { t } = useTranslation();
  const profileType = isMp ? ProfileType.Matching : undefined;
  const { data, loading } = useLoadAllMpsIds(false, profileType);
  const mps = data?.getAllMyMatchingProfiles;

  const values = useMemo(
    () =>
      (mps || []).map(mp => {
        return {
          value: mp.id,
          label: mp.name
        };
      }),
    [mps]
  );

  const onSelectCB = useCallback(
    id => {
      updateSelectValue(id);
    },
    [updateSelectValue]
  );

  return (
    <>
      <PlainDropDown
        hideLabel={!!selectedValue}
        selectedValue={selectedValue}
        values={values}
        onSelect={onSelectCB}
        label={placeholder || t('Tenders.selectProfile')}
        loading={loading}
        disabled={!values.length}
        type="single"
      />
    </>
  );
};

export default MPSelect;
